<template>
  <label class="file-select w-100 mb-0">
    <div class="select-button btn btn-info btn-block">
      <span v-if="value"><i class="fa fa-file" aria-hidden="true"></i> {{value.name}}</span>
      <span v-else><i class="fa fa-file" aria-hidden="true"></i> Seleccionar archivo</span>
    </div>
    <input type="file" @change="handleFileChange"/>
	
  </label>
</template>

<script>
export default {
  props: {
    value: File
  },

  methods: {
    handleFileChange (e) {
      this.$emit('input', e.target.files[0])
    }
  }
}
</script>

<style scoped>
.file-select > .select-button {}

.file-select > input[type="file"] {
  display: none;
}

</style>
